import React from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { Helmet } from "react-helmet";

import AdmissionRequest from "../../components/AdmissionApproval/AdmissionRequest";
import ProfileUpdateRequest from "../../components/AdmissionApproval/ProfileUpdateRequest";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import { tabsClasses, useMediaQuery } from "@mui/material";

const AdmissionApproval = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Admission Approval</title>
      </Helmet>

      <TabContext value={value}>
        <TabsWrapper sx={{ width: isMobile ? "100%" : "auto" }}>
          <TabList
            variant="scrollable"
            scrollButtons={isMobile}
            allowScrollButtonsMobile
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              width: isMobile ? "85vw" : "auto",
            }}
            aria-label="basic tabs example"
            onChange={handleChange}
          >
            <Tab label="Admission Request" value="1" />
            <Tab label="Profile Update Request" value="2" />
          </TabList>
        </TabsWrapper>
        <TabPanel value="1" sx={{ p: "0 !important" }}>
          <AdmissionRequest />
        </TabPanel>
        <TabPanel value="2" sx={{ p: "0 !important" }}>
          <ProfileUpdateRequest />
        </TabPanel>
      </TabContext>
    </>
  );
};

export default AdmissionApproval;
